import React from 'react';

const CompanyBar = ({ companyName }) => {

    if (!companyName) return null;
        return (
            <div className="companybar">
                <p>{companyName}</p>
            </div>
        );
}

export default CompanyBar;
